<table class="table is-fullwidth is-striped is-hoverable">
    <thead>
      <tr>
        <th *ngFor="let column of columnsHeader"
          [ngClass]="{'has-text-centered': column.isCentered, 'is-clickable': column.isSorteable }"
          (click)="sortColumns(column)">
          <span>{{ column.title }}</span>
          <span class="arrows-sort" *ngIf="column.isSorteable">
            <span class="arrow-icon" [ngClass]="{'sort-active': column.sort === 'up'}">
              <fa-icon [icon]="faArrowUp"></fa-icon>
            </span>
            <span class="arrow-icon" [ngClass]="{'sort-active': column.sort === 'down'}">
              <fa-icon [icon]="faArrowDown"></fa-icon>
            </span>
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      @for(item of dataTable; track item) {
        <tr [ngClass]="{'has-apo-errors': item.template === false, 'type-new': item.tipo === 'new' }">
          @for(column of columnsHeader; track column) {
            <td
            [ngClass]="{'has-text-centered': column.isCentered, 'has-tooltip-arrow has-tooltip-bottom': !item.template === false}"
            [attr.data-tooltip]="item.errorsDesc" (click)="selectRow(item, column)">
            <span *ngIf="(column.type === 'string' || column.type === 'number') && (!item.envasadora_orders || column.key === 'weight')">
              {{ item[column.key] }}
            </span>
            <span *ngIf="(column.type === 'object' && item[column.key])">
              {{ item[column.key].description }}
            </span>
            <span *ngIf="(column.key === 'product_grad' && item.product)">
              {{ item.product.id }}
            </span>
            <!-- <span *ngIf="(column.key === 'fert' && column.isViewApo && item.material)">
              {{ item.material.fert }}
            </span> -->
            <span *ngIf="column.type === 'date'">
              {{ item[column.key] ? getDateWithFormat(item[column.key]) : ''}}
            </span>
            <span *ngIf="column.type === 'boolean' && column.isCheckField">
              <div *ngIf="!column.isViewApo">
                <fa-icon class="icon-active" [ngClass]="{'has-text-success': item[column.key] }"
                  [icon]="faActiveCheck"></fa-icon>
              </div>
              <div *ngIf="column.isViewApo">
                <fa-icon *ngIf="((item.tipo === 'order' || item.tipo === 'new') && item['reactor_load_kanbanize']) || (item.tipo === 'limpieza' && item['limpieza_load_kanbanize'] && item['reactor_load_kanbanize'])" class="icon-active" [ngClass]="{'has-text-success': item[column.key] }" [icon]="faActiveCheck"></fa-icon>
                <fa-icon
                  *ngIf="((item.tipo === 'order' || item.tipo === 'new') && !item['reactor_load_kanbanize']) || (item.tipo === 'limpieza' && (!item['limpieza_load_kanbanize'] || !item['reactor_load_kanbanize']))"
                  class="icon-active has-text-danger" [icon]="faCloseCheck"></fa-icon>
              </div>
            </span>
            <span *ngIf="column.type === 'array'">
              <span *ngFor="let itemArray of item[column.key]" class="tag is-primary mr-2">
                {{ itemArray }}
              </span>
            </span>
            <span *ngIf="column.type === 'enum'" [ngClass]="item[column.key]">
              {{ item[column.key] }}
  
            </span>
            <span *ngIf="column.isColumnDelete">
              <fa-icon class="icon-delete" [icon]="iconDelete" title="Eliminar"></fa-icon>
            </span>
          </td>
          }
        </tr>
        @if (item.envasadora_orders && item.envasadora_orders.length > 0) {
          @for(subItem of item.envasadora_orders; track subItem) {
            <tr [ngClass]="{'has-apo-errors': item.template === false, 'type-new': item.tipo === 'new' }">
              @for(column of columnsHeader; track column) {
                <td
                [ngClass]="{'has-text-centered': column.isCentered, 'has-tooltip-arrow has-tooltip-bottom': !item.template === false}"
                [attr.data-tooltip]="item.errorsDesc" (click)="selectRow(item, column)">
                <span *ngIf="(column.type === 'string' || column.type === 'number') && column.key !== 'weight'">
                  {{ subItem[column.key] }}
                </span>
                <span *ngIf="(column.type === 'object' && subItem[column.key])">
                  {{ subItem[column.key].description }}
                </span>
                <span *ngIf="(column.key === 'product_grad' && subItem.product)">
                  {{ subItem.product.id }}
                </span>
                <span *ngIf="(column.key === 'fert' && column.isViewApo && subItem.material)">
                  {{ subItem.material.fert }}
                </span>
                <span *ngIf="column.type === 'date' && column.key !== 'fecha_carga'">
                  {{ subItem[column.key] ? getDateWithFormat(subItem[column.key]) : '' }}
                </span>
                <span *ngIf="column.type === 'boolean' && column.isCheckField">
                  <div *ngIf="!column.isViewApo">
                    <fa-icon class="icon-active" [ngClass]="{'has-text-success': item[column.key] }"
                      [icon]="faActiveCheck"></fa-icon>
                  </div>
                  <div *ngIf="column.isViewApo">
                    <fa-icon *ngIf="((item.tipo === 'order' || item.tipo === 'new') && item['reactor_load_kanbanize']) || (item.tipo === 'limpieza' && item['limpieza_load_kanbanize'] && item['reactor_load_kanbanize'])" class="icon-active" [ngClass]="{'has-text-success': item[column.key] }" [icon]="faActiveCheck"></fa-icon>
                    <fa-icon
                      *ngIf="((item.tipo === 'order' || item.tipo === 'new') && !item['reactor_load_kanbanize']) || (item.tipo === 'limpieza' && (!item['limpieza_load_kanbanize'] || !item['reactor_load_kanbanize']))"
                      class="icon-active has-text-danger" [icon]="faCloseCheck"></fa-icon>
                  </div>
                </span>
                <span *ngIf="column.type === 'array'">
                  <span *ngFor="let subItemArray of subItem[column.key]" class="tag is-primary mr-2">
                    {{ subItemArray }}
                  </span>
                </span>
                <span *ngIf="column.type === 'enum'" [ngClass]="subItem[column.key]">
                  {{ subItem[column.key] }}
      
                </span>
                <span *ngIf="column.isColumnDelete">
                </span>
              </td>
              }
            </tr>
          }
          
        }
      } @empty {
        <tr>
            <td class="has-text-centered" [attr.colspan]="columnsHeader.length">No hay datos</td>
        </tr>
      }
      
    </tbody>
  </table>
  <div class="modal" [ngClass]="{'is-active': isModalDeleteConfirm }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head modal-card-head-delete">
        <p class="modal-card-title">Confirmar eliminar</p>
        <button type="button" class="delete" aria-label="close" (click)="isModalDeleteConfirm = false"></button>
      </header>
      <section class="modal-card-body modal-card-body-delete">
        <div class="columns">
          <div class="column">
            <p class="message-confirm-delete">¿Estás seguro/a que deseas continuar?</p>
            <p class="message-confirm-delete" *ngIf="isInKBZ"><em>(La orden también se eliminará de Kanbanize)</em></p>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot is-justify-content-space-between">
        <button type="button" class="button" (click)="isModalDeleteConfirm = false">Cancelar</button>
        <button type="submit" class="button is-danger" (click)="delete()">Eliminar</button>
      </footer>
    </div>
  </div>